import React from "react";

const NonAuthLayout = ({ children }) => {
  return (
    <div id="NonAuthLayout" className="h-screen">
      <div className="content">{children}</div>
    </div>
  );
};

export default NonAuthLayout;
